<div class="profile-container">
    <div class="profile-content">
        <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                    <div class="search">
                        <form autocomplete="off">
                            <input type="text" placeholder="search" (keyup.enter)="getClientInfoByWildSearch()"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
                        </form>
                        <i class="bi bi-search" (click)="getClientInfoByWildSearch()"></i>
                    </div>
                    <button title="Add" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{
                        'generic.add' | translate
                        }}</button>
                    <div class="filter-icon">
                        <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                </div>
            </div>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 20%;">Company Name</th>
                        <th style="width: 25%;">Email Id</th>
                        <th style="width: 20%;">Phone Number</th>
                        <th style="width: 25%;">Industry</th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate
                            }}</th>
                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
                <div class="data-view" id="{{client.id}}"
                    [ngClass]="{ 'delete-highlight': client.clientInfoId == recordId }" *ngFor="let client of filteredClientInfoData | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }  ;let i = index">

                    <p style="width: 20%;">{{client.companyName || " -- " }}</p>
                    <p style="width: 25%;">{{client.companyEmailId || " -- " }}</p>
                    <p style="width: 20%;">{{client.phoneNumber || " -- " }}</p>
                    <p style="width: 25%;">{{client.industryType || " -- " }}</p>

                    <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i data-toggle="modal" title="View" (click)="viewClientInfoById(client.clientInfoId)"
                            data-target="#viewModal" class="bi bi-eye-fill"></i>
                        <i *ngIf="actionControls.isModify" title="Edit" class="bi bi-pencil-square"
                            (click)="getClientInfoById(client.clientInfoId)" data-toggle="modal"
                            data-target="#editModal"></i>
                        <i *ngIf="actionControls.isDelete" title="Delete" class="bi bi-trash3"
                            (click)="deleteIdSelect(client.id,client)" data-toggle="modal"
                            data-target="#deleteModal"></i>
                    </p>
                </div>
            </div>

            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && filteredClientInfoData.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" (click)="clearData()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleteClientInfo()" class="btn btn-primary">{{ 'generic.delete' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Add Client Config
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="clientInfoForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Company Name <span class="required">*</span></label>
                                <input formControlName="companyName" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoForm.get('companyName').invalid && formSubmit">Company Name
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Company Email <span class="required">*</span></label>
                                <input formControlName="companyEmailId" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoForm.get('companyEmailId').invalid && formSubmit">Email
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Phone Number <span class="required">*</span></label>
                                <input formControlName="phoneNumber" type="number" class="form-control">
                                <span class="err" *ngIf="clientInfoForm.get('phoneNumber').invalid && formSubmit">Phone
                                    Number required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Industry Type <span class="required">*</span></label>
                                <select class="form-control" formControlName="industryType">
                                    <option value="" disabled selected>Select Industry</option>
                                    <option *ngFor="let industry of industryTypes" [value]="industry.value">
                                        {{ industry.viewValue }}
                                    </option>
                                </select>
                                <span class="err"
                                    *ngIf="clientInfoForm.get('industryType').invalid && formSubmit">Industry Type
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>SMS Key <span class="required">*</span></label>
                                <input formControlName="smsKey" type="text" class="form-control">
                                <span class="err" *ngIf="clientInfoForm.get('smsKey').invalid && formSubmit">SMS Key
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>SendGrid Key <span class="required">*</span></label>
                                <input formControlName="sendGridKey" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoForm.get('sendGridKey').invalid && formSubmit">SendGrid Key
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Razorpay Currency <span class="required">*</span></label>
                                <input formControlName="razorpayCurrency" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoForm.get('razorpayCurrency').invalid && formSubmit">Razorpay
                                    Currency required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Razorpay Key ID <span class="required">*</span></label>
                                <input formControlName="razorpayKeyId" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoForm.get('razorpayKeyId').invalid && formSubmit">Razorpay Key ID
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>MSG Whatsapp Number <span class="required">*</span></label>
                                <input formControlName="msgWhatsappNumber" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoForm.get('msgWhatsappNumber').invalid && formSubmit">MSG Whatsapp
                                    Number required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>MSG91 Auth Key <span class="required">*</span></label>
                                <input formControlName="msg91AuthKey" type="text" class="form-control">
                                <span class="err" *ngIf="clientInfoForm.get('msg91AuthKey').invalid && formSubmit">MSG91
                                    Auth Key required</span>
                            </div>
                        </div>

                        <!-- Checkboxes -->
                        <div class="col-md-12 mt-3 mb-2">
                            <h5>Configuration Settings</h5>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="msg91_CREATE_TICKET_FOR_REGISTERED_ONLY" type="checkbox"
                                            id="addCheck1">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="addCheck1" style="display: inline-block; margin-bottom: 0;">Create
                                        Ticket For Registered Only</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN" type="checkbox"
                                            id="addCheck2">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="addCheck2" style="display: inline-block; margin-bottom: 0;">Task Status
                                        Update To Technician</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="updated_MATERIAL_ON_ISSUED" type="checkbox"
                                            id="addCheck3">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="addCheck3" style="display: inline-block; margin-bottom: 0;">Update
                                        Material On Issued</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL"
                                            type="checkbox" id="addCheck4">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="addCheck4" style="display: inline-block; margin-bottom: 0;">Update
                                        Balances On Material Issue Approval</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="material_ISSUE_SEQUENE_AUTOGENERATE" type="checkbox"
                                            id="addCheck5">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="addCheck5" style="display: inline-block; margin-bottom: 0;">Material
                                        Issue Sequence Autogenerate</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="customer_AUTO_APPROVED" type="checkbox" id="addCheck6">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="addCheck6" style="display: inline-block; margin-bottom: 0;">Customer
                                        Auto Approved</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="auto_TICKET_CREATION_AT_INVOICE_PAYMENT" type="checkbox"
                                            id="addCheck7">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="addCheck7" style="display: inline-block; margin-bottom: 0;">Auto Ticket
                                        Creation At Invoice Payment</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="vendor_AUTO_APPROVED" type="checkbox" id="addCheck8">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="addCheck8" style="display: inline-block; margin-bottom: 0;">Vendor Auto
                                        Approved</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="user_CREATION_ON_VENDOR_APPROVED" type="checkbox"
                                            id="addCheck9">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="addCheck9" style="display: inline-block; margin-bottom: 0;">User
                                        Creation On Vendor Approved</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2" (click)="closePopUp()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="addClientInfo()" class="btn btn-primary">{{ 'generic.add' | translate
                        }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Edit Client Config
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="clientInfoUpdateForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Company Name <span class="required">*</span></label>
                                <input formControlName="companyName" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoUpdateForm.get('companyName').invalid && formSubmit">Company Name
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Company Email <span class="required">*</span></label>
                                <input formControlName="companyEmailId" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoUpdateForm.get('companyEmailId').invalid && formSubmit">Email
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Phone Number <span class="required">*</span></label>
                                <input formControlName="phoneNumber" type="number" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoUpdateForm.get('phoneNumber').invalid && formSubmit">Phone Number
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Industry Type <span class="required">*</span></label>
                                <select class="form-control" formControlName="industryType">
                                    <option value="" disabled selected>Select Industry</option>
                                    <option *ngFor="let industry of industryTypes" [value]="industry.value">
                                        {{ industry.viewValue }}
                                    </option>
                                </select>
                                <span class="err"
                                    *ngIf="clientInfoUpdateForm.get('industryType').invalid && formSubmit">Industry Type
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>SMS Key <span class="required">*</span></label>
                                <input formControlName="smsKey" type="text" class="form-control">
                                <span class="err" *ngIf="clientInfoUpdateForm.get('smsKey').invalid && formSubmit">SMS
                                    Key required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>SendGrid Key <span class="required">*</span></label>
                                <input formControlName="sendGridKey" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoUpdateForm.get('sendGridKey').invalid && formSubmit">SendGrid Key
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Razorpay Currency <span class="required">*</span></label>
                                <input formControlName="razorpayCurrency" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoUpdateForm.get('razorpayCurrency').invalid && formSubmit">Razorpay
                                    Currency required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Razorpay Key ID <span class="required">*</span></label>
                                <input formControlName="razorpayKeyId" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoUpdateForm.get('razorpayKeyId').invalid && formSubmit">Razorpay Key
                                    ID required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>MSG Whatsapp Number <span class="required">*</span></label>
                                <input formControlName="msgWhatsappNumber" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoUpdateForm.get('msgWhatsappNumber').invalid && formSubmit">MSG
                                    Whatsapp Number required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>MSG91 Auth Key <span class="required">*</span></label>
                                <input formControlName="msg91AuthKey" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="clientInfoUpdateForm.get('msg91AuthKey').invalid && formSubmit">MSG91 Auth
                                    Key required</span>
                            </div>
                        </div>

                        <!-- Checkboxes -->
                        <div class="col-md-12 mt-3 mb-2">
                            <h5>Configuration Settings</h5>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="msg91_CREATE_TICKET_FOR_REGISTERED_ONLY" type="checkbox"
                                            id="editCheck1">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="editCheck1" style="display: inline-block; margin-bottom: 0;">Create
                                        Ticket For Registered Only</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN" type="checkbox"
                                            id="editCheck2">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="editCheck2" style="display: inline-block; margin-bottom: 0;">Task Status
                                        Update To Technician</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="updated_MATERIAL_ON_ISSUED" type="checkbox"
                                            id="editCheck3">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="editCheck3" style="display: inline-block; margin-bottom: 0;">Update
                                        Material On Issued</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL"
                                            type="checkbox" id="editCheck4">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="editCheck4" style="display: inline-block; margin-bottom: 0;">Update
                                        Balances On Material Issue Approval</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="material_ISSUE_SEQUENE_AUTOGENERATE" type="checkbox"
                                            id="editCheck5">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="editCheck5" style="display: inline-block; margin-bottom: 0;">Material
                                        Issue Sequence Autogenerate</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="customer_AUTO_APPROVED" type="checkbox" id="editCheck6">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="editCheck6" style="display: inline-block; margin-bottom: 0;">Customer
                                        Auto Approved</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="auto_TICKET_CREATION_AT_INVOICE_PAYMENT" type="checkbox"
                                            id="editCheck7">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="editCheck7" style="display: inline-block; margin-bottom: 0;">Auto Ticket
                                        Creation At Invoice Payment</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="vendor_AUTO_APPROVED" type="checkbox" id="editCheck8">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="editCheck8" style="display: inline-block; margin-bottom: 0;">Vendor Auto
                                        Approved</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="user_CREATION_ON_VENDOR_APPROVED" type="checkbox"
                                            id="editCheck9">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="editCheck9" style="display: inline-block; margin-bottom: 0;">User
                                        Creation On Vendor Approved</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalButton3" (click)="closePopUp()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="updateClientInfo()" class="btn btn-primary">{{ 'generic.update' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="viewModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="viewModalLabel">View Client Config
                    <span class="header-action" data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="service-data" *ngFor="let viewData of singleClientInfoData">
                    <div class="form-group">
                        <div class="row" style="margin-bottom: 20px;">
                            <div class="col-md-6 col-lg-6">
                                <label>Company Name :</label>
                                <p>{{viewData.companyName || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Company Email :</label>
                                <p>{{viewData.companyEmailId || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Phone Number :</label>
                                <p>{{viewData.phoneNumber || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Industry Type :</label>
                                <p>{{viewData.industryType || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>SMS Key :</label>
                                <p>{{viewData.smsKey || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>SendGrid Key :</label>
                                <p>{{viewData.sendGridKey || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Razorpay Currency :</label>
                                <p>{{viewData.razorpayCurrency || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Razorpay Key ID :</label>
                                <p>{{viewData.razorpayKeyId || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>MSG Whatsapp Number :</label>
                                <p>{{viewData.msgWhatsappNumber || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>MSG91 Auth Key :</label>
                                <p>{{viewData.msg91AuthKey || '--'}}</p>
                            </div>

                            <div class="col-md-12 col-lg-12 mt-2 mb-2">
                                <h5>Configuration Settings</h5>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Create Ticket For Registered Only :</label>
                                <p>{{viewData.msg91_CREATE_TICKET_FOR_REGISTERED_ONLY ? 'Yes' : 'No'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Task Status Update To Technician :</label>
                                <p>{{viewData.msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN ? 'Yes' : 'No'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Update Material On Issued :</label>
                                <p>{{viewData.updated_MATERIAL_ON_ISSUED ? 'Yes' : 'No'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Update Balances On Material Issue Approval :</label>
                                <p>{{viewData.update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL ? 'Yes' : 'No'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Material Issue Sequence Autogenerate :</label>
                                <p>{{viewData.material_ISSUE_SEQUENE_AUTOGENERATE ? 'Yes' : 'No'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Customer Auto Approved :</label>
                                <p>{{viewData.customer_AUTO_APPROVED ? 'Yes' : 'No'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Auto Ticket Creation At Invoice Payment :</label>
                                <p>{{viewData.auto_TICKET_CREATION_AT_INVOICE_PAYMENT ? 'Yes' : 'No'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Vendor Auto Approved :</label>
                                <p>{{viewData.vendor_AUTO_APPROVED ? 'Yes' : 'No'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>User Creation On Vendor Approved :</label>
                                <p>{{viewData.user_CREATION_ON_VENDOR_APPROVED ? 'Yes' : 'No'}}</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closePopUp()">{{
                    'generic.close' | translate }}</button>
            </div>
        </div>
    </div>
</div>